import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateCaresenseLogoutUrl } from './config';
import {
  parseTokenFromUrl,
  validateCaresenseToken,
} from '../AnyfitMall/common';
import CaresenseLayout from 'components/Caresense/CaresenseLayout';
import CaresenseLoading from 'components/Caresense/CaresenseLoading';
import { navigateToCaresenseError } from './caresenseErrors';

/**
 * 케어센스 OAuth 로그인 진입점
 * 전체 플로우: Login(0-15%) → LogoutCallback(15-30%) → OAuth → Callback(30-100%)
 */
export default function CaresenseLogin() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const initializeOAuth = async () => {
      const isDev = ['local', 'dev'].includes(process.env.REACT_APP_ENV);

      try {
        setProgress(5);

        // 1. URL에서 초기 토큰 파싱
        const initialToken = parseTokenFromUrl();

        if (!initialToken) {
          navigateToCaresenseError(navigate);
          return;
        }

        // 2. 토큰 저장
        localStorage.setItem('token', initialToken);

        setProgress(10);

        // 3. 토큰 검증 (케어센스용 - B2B/B2C 모두 허용)
        const validationResult = await validateCaresenseToken(initialToken);
        if (!validationResult.result) {
          navigateToCaresenseError(navigate);
          return;
        }

        // 4. Division 별도 저장 (외부 리다이렉트 후 브랜딩 유지용)
        if (validationResult.division) {
          localStorage.setItem('division', validationResult.division);
        }

        setProgress(15);

        // 5. 케어센스 로그아웃 URL 생성 (기존 세션 정리)
        const logoutUrl = generateCaresenseLogoutUrl();

        if (isDev) {
          console.log('[Caresense] 로그아웃으로 리다이렉트:', {
            logoutUrl,
            목적: '기존 케어센스 세션 정리 후 OAuth 진입',
          });
        }

        // 6. 케어센스 로그아웃 페이지로 리다이렉트
        // 로그아웃 완료 후 /caresense/logout-callback으로 돌아옴
        setTimeout(() => {
          window.location.href = logoutUrl;
        }, 500);
      } catch (error) {
        console.error('[Caresense] 초기화 오류:', error);
        navigateToCaresenseError(navigate);
      }
    };

    initializeOAuth();
  }, [navigate]);

  return (
    <CaresenseLayout>
      <CaresenseLoading progress={progress} title="케어센스 연동 준비 중" />
    </CaresenseLayout>
  );
}
